// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IParticipantDemographicsInfoDto } from './IParticipantDemographicsInfoDto';
import {
    IParticipantDemographicsInfoDtoFromJSON,
    IParticipantDemographicsInfoDtoFromJSONTyped,
    IParticipantDemographicsInfoDtoToJSON,
    IParticipantDemographicsInfoDtoToJSONTyped,
} from './IParticipantDemographicsInfoDto';
import type { IParticipantAddressInfoDto } from './IParticipantAddressInfoDto';
import {
    IParticipantAddressInfoDtoFromJSON,
    IParticipantAddressInfoDtoFromJSONTyped,
    IParticipantAddressInfoDtoToJSON,
    IParticipantAddressInfoDtoToJSONTyped,
} from './IParticipantAddressInfoDto';
import type { IParticipantEmploymentInfoDto } from './IParticipantEmploymentInfoDto';
import {
    IParticipantEmploymentInfoDtoFromJSON,
    IParticipantEmploymentInfoDtoFromJSONTyped,
    IParticipantEmploymentInfoDtoToJSON,
    IParticipantEmploymentInfoDtoToJSONTyped,
} from './IParticipantEmploymentInfoDto';

/**
 * 
 * @export
 * @interface IEmployeeInfoCreateAggregatorDto
 */
export interface IEmployeeInfoCreateAggregatorDto {
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    is_employee_email_preferred?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    employer_provided_email: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    phone1?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    phone2?: IPhoneInfoDto;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    mailing_address: IParticipantAddressInfoDto;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    physical_address: IParticipantAddressInfoDto;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    hire_on?: Date;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {IParticipantEmploymentInfoDto}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    employment_info: IParticipantEmploymentInfoDto;
    /**
     * 
     * @type {IParticipantDemographicsInfoDto}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    demographics_info: IParticipantDemographicsInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoCreateAggregatorDto
     */
    payroll_group_code?: string;
}

/**
 * Check if a given object implements the IEmployeeInfoCreateAggregatorDto interface.
 */
export function instanceOfIEmployeeInfoCreateAggregatorDto(value: object): value is IEmployeeInfoCreateAggregatorDto {
    if (!('employer_provided_email' in value) || value['employer_provided_email'] === undefined) return false;
    if (!('mailing_address' in value) || value['mailing_address'] === undefined) return false;
    if (!('physical_address' in value) || value['physical_address'] === undefined) return false;
    if (!('employment_info' in value) || value['employment_info'] === undefined) return false;
    if (!('demographics_info' in value) || value['demographics_info'] === undefined) return false;
    return true;
}

export function IEmployeeInfoCreateAggregatorDtoFromJSON(json: any): IEmployeeInfoCreateAggregatorDto {
    return IEmployeeInfoCreateAggregatorDtoFromJSONTyped(json, false);
}

export function IEmployeeInfoCreateAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeInfoCreateAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_employee_email_preferred': json['is_employee_email_preferred'] == null ? undefined : json['is_employee_email_preferred'],
        'employer_provided_email': json['employer_provided_email'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'phone1': json['phone1'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone1']),
        'phone2': json['phone2'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone2']),
        'mailing_address': IParticipantAddressInfoDtoFromJSON(json['mailing_address']),
        'physical_address': IParticipantAddressInfoDtoFromJSON(json['physical_address']),
        'hire_on': json['hire_on'] == null ? undefined : (new Date(json['hire_on'])),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'employment_info': IParticipantEmploymentInfoDtoFromJSON(json['employment_info']),
        'demographics_info': IParticipantDemographicsInfoDtoFromJSON(json['demographics_info']),
        'payroll_group_code': json['payroll_group_code'] == null ? undefined : json['payroll_group_code'],
    };
}

export function IEmployeeInfoCreateAggregatorDtoToJSON(json: any): IEmployeeInfoCreateAggregatorDto {
    return IEmployeeInfoCreateAggregatorDtoToJSONTyped(json, false);
}

export function IEmployeeInfoCreateAggregatorDtoToJSONTyped(value?: IEmployeeInfoCreateAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'employer_provided_email': value['employer_provided_email'],
        'employee_provided_email': value['employee_provided_email'],
        'phone1': IPhoneInfoDtoToJSON(value['phone1']),
        'phone2': IPhoneInfoDtoToJSON(value['phone2']),
        'mailing_address': IParticipantAddressInfoDtoToJSON(value['mailing_address']),
        'physical_address': IParticipantAddressInfoDtoToJSON(value['physical_address']),
        'hire_on': value['hire_on'] == null ? undefined : ((value['hire_on']).toISOString().substring(0,10)),
        'organization_id': value['organization_id'],
        'employment_info': IParticipantEmploymentInfoDtoToJSON(value['employment_info']),
        'demographics_info': IParticipantDemographicsInfoDtoToJSON(value['demographics_info']),
        'payroll_group_code': value['payroll_group_code'],
    };
}

